var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.515 10C21.624 10 21.178 11.077 21.808 11.707L23.636 13.536L17.979 19.193C17.198 19.974 17.198 21.24 17.979 22.021C18.76 22.802 20.026 22.802 20.807 22.021L26.464 16.364L28.293 18.192C28.923 18.822 30 18.376 30 17.485V10H22.515ZM28.5 23C27.673 23 27 23.673 27 24.5V26.7C27 26.865 26.865 27 26.7 27H13.3C13.135 27 13 26.865 13 26.7V13.3C13 13.135 13.135 13 13.3 13H15.5C16.327 13 17 12.327 17 11.5C17 10.673 16.327 10 15.5 10H13.3C11.48 10 10 11.48 10 13.3V26.7C10 28.52 11.48 30 13.3 30H26.7C28.519 30 30 28.52 30 26.7V24.5C30 23.673 29.327 23 28.5 23Z",
    fill: "#848EAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.553cf6e7a59bacbe82376b668a58b142.svg";
export { ForwardRef as ReactComponent };